<template>
<div class='story-container' ref="storyContainer">
  <div class='detail-ad-container'></div>
  <div class='story-top-container' v-if='story_related.title != null'>
    <div class='story-headline'>{{story_related.title}}</div>
    <div class='story-category'>
      <!-- <img :src="story_related.authorAvatar ? story_related.authorAvatar : defaultPortrait" class='author-avatar' @error="setDefaultPortrait"/> -->
      <div class='author-name'>{{story_related.author}}</div>
    </div>
  </div>
  <div class='story-content-container' id='storycontent'>
    <div v-if="content_element_list === null" class='loading'>正在加载文章...</div>
    <div v-else-if="content_element_list === false" class='loading-failure'>文章加载失败！</div>
    <div v-else-if="content_element_list && content_element_list.length === 0" class='empty'>文章为空！</div>
    <div v-else>
      <div v-for="(item, index) in content_element_list" :key="index">
        <div v-if='(index + 1) % 4 === 0' class='detail-ad-container'></div>
        <div class='content-text content-item' v-if="item.type === 1">{{item.content}}</div>
        <img class='content-img content-item' v-else-if="item.type === 2" v-lazy.storycontent="item.picture" @error='setDefaultImg'/>
        <div class='subtitle content-item' v-else-if="item.type === 3">{{item.content}}</div>
        <div class='content-text content-item' v-else>{{item.content}}</div>
      </div>
    </div>
  </div>
  <div class="recommend">
    <div class='recommend-title'>
      <h2>相关推荐<span class='line'></span></h2>
    </div>
    <div class='recommend-content'>
      <div v-for="(relatedItem, index) in relatedNewsList" v-bind:key='index'>
          <div v-if="index % 2 === 0" class='related-ad-container'></div>
          <ListItemComponent :item="relatedItem" @click.native="handleItemClick(index)" />
      </div>
    </div>
  </div>
  <div class='goto-index' @click='gotoIndexPage'>返回首页</div>
</div>
</template>

<script>
import {Swipe, SwipeItem} from 'mint-ui';
import ListItemComponent from "./ListItemComponent";
export default {
  data: function () {
    return {
      content_element_list: null,
      story_related: {},
      defaultPortrait: require('../assets/default_portrait.png'),
      defaultImg: require('../assets/default_img.png'),
      relatedNewsList: [],
    }
  },
  name: 'Detail',
  components: {
    "mt-swipe": Swipe,
    "mt-swipe-item": SwipeItem
  },
  components: {
    ListItemComponent,
  },
  mounted() {
    console.log('this.$route: ', this.$route);
    const match_result = window.location && window.location.search && window.location.search.match(/\?user_id=(\d+)/);
    if (match_result && match_result[1]) {
      this.user_id = match_result[1];
    }
    const data_url = decodeURIComponent(this.$route.params.story_url);
    this.story_related = this.$route.params.story_related || {};
    this.getStoryDetail(data_url);
    this.getRelatedInfo();
  },
  watch: {
    // 第一次从index页面跳转到detail页面时，由于detail组件还没有创建，所以watch $route不会被执行
    // https://segmentfault.com/q/1010000014550472/a-1020000014550760
    // https://segmentfault.com/q/1010000009423412
    '$route' (to, from) {
      console.log('$route from: ', from);
      console.log("$route to: ", to);
      if (to.name === 'detail') {
        // console.log("document.body.scrollTop: ", document.documentElement.scrollTop);
        this.$refs['storyContainer'].scrollTop = 0;
        // 由于组件是keep-alive的，因此进入新的页面之前要清空原来的内容
        this.content_element_list = null;
        // this.relatedNewsList = [];
        this.story_related = to.params.story_related || {};
        const data_url = decodeURIComponent(to.params.story_url);
        this.getStoryDetail(data_url);
        // this.getRelatedInfo();
      }
    }
  },
  methods: {
    getStoryDetail: function (data_url) {
      this.axios({
        method: 'GET',
        url: data_url,
      }).then(resp => {
        this.content_element_list = resp.data;
        this.$nextTick(() => {
          let ads = document.getElementsByClassName('detail-ad-container');
          [].forEach.call(ads, (elem, index) => {
            switch ( index % 6) {
              case 0:
                if (!elem.getElementsByClassName('sogou-wrap').length) {
                  let ad = document.createElement('div');
                  ad.className = "sogou-wrap";
                  // ad.innerHTML = "<iframe src='./sogou001.html' frameborder='0' scrolling='no' width='100%' height='100'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130;
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='${height}'></iframe>`;
                  elem.appendChild(ad);
                }
                break;
              case 1:
                if (!elem.getElementsByClassName('sogou-wrap').length) {
                  let ad = document.createElement('div');
                  ad.className = "sogou-wrap";
                  // ad.innerHTML = "<iframe src='./sogou002.html' frameborder='0' scrolling='no' width='100%' height='130'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130;
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='${height}'></iframe>`;
                  elem.appendChild(ad);
                }
                break;
              case 2:
                if (!elem.getElementsByClassName('sogou-wrap').length) {
                  let ad = document.createElement('div');
                  ad.className = "sogou-wrap";
                  // ad.innerHTML = "<iframe src='./sogou003.html' frameborder='0' scrolling='no' width='100%' height='100'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130;
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='${height}'></iframe>`;
                  elem.appendChild(ad);
                }
                break;
              case 3:
                if (!elem.getElementsByClassName('sogou-wrap').length) {
                  let ad = document.createElement('div');
                  ad.className = "sogou-wrap";
                  // ad.innerHTML = "<iframe src='./sogou004.html' frameborder='0' scrolling='no' width='100%' height='130'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130;
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='${height}'></iframe>`;
                  elem.appendChild(ad);
                }
                break;
              case 4:
                if (!elem.getElementsByClassName('sogou-wrap').length) {
                  let ad = document.createElement('div');
                  ad.className = "sogou-wrap";
                  // ad.innerHTML = "<iframe src='./sogou005.html' frameborder='0' scrolling='no' width='100%' height='100'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130;
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='${height}'></iframe>`;
                  elem.appendChild(ad);
                }
                break;
              case 5:
                if (!elem.getElementsByClassName('sogou-wrap').length) {
                  let ad = document.createElement('div');
                  ad.className = "sogou-wrap";
                  // ad.innerHTML = "<iframe src='./sogou006.html' frameborder='0' scrolling='no' width='100%' height='130'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130;
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='${height}'></iframe>`;
                  elem.appendChild(ad);
                }
                break;
            }
          });
        });
      }).catch(rej => {
        console.log('rej: ', rej);
      })
    },
    getRelatedInfo: function () {
      this.axios({
        method: 'POST',
        url: `https://api.dianxiao.feedadx.com/dianxiao/news/list`,
        data: {
          'newsChannel': 1,
          'lastRecordId': undefined,
        }
      }).then(res => {
        // console.log('res: ', res);
        this.relatedNewsList = res.data.newsInfoList;
        this.$nextTick(() => {
            let ads = document.getElementsByClassName('related-ad-container');
            [].forEach.call(ads, (elem, index) => {
              switch ( index % 6) {
                case 0:
                  if (!elem.getElementsByClassName('sogou-wrap').length) {
                    let ad = document.createElement('div');
                    ad.className = "sogou-wrap";
                    // ad.innerHTML = "<iframe src='./sogou001.html' frameborder='0' scrolling='no' width='100%' height='100'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130;
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='${height}'></iframe>`;
                    elem.appendChild(ad);
                  }
                  break;
                case 1:
                  if (!elem.getElementsByClassName('sogou-wrap').length) {
                    let ad = document.createElement('div');
                    ad.className = "sogou-wrap";
                    // ad.innerHTML = "<iframe src='./sogou002.html' frameborder='0' scrolling='no' width='100%' height='130'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130;
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='${height}'></iframe>`;
                    elem.appendChild(ad);
                  }
                  break;
                case 2:
                  if (!elem.getElementsByClassName('sogou-wrap').length) {
                    let ad = document.createElement('div');
                    ad.className = "sogou-wrap";
                    // ad.innerHTML = "<iframe src='./sogou003.html' frameborder='0' scrolling='no' width='100%' height='100'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130;
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='${height}'></iframe>`;
                    elem.appendChild(ad);
                  }
                  break;
                case 3:
                  if (!elem.getElementsByClassName('sogou-wrap').length) {
                    let ad = document.createElement('div');
                    ad.className = "sogou-wrap";
                    // ad.innerHTML = "<iframe src='./sogou004.html' frameborder='0' scrolling='no' width='100%' height='130'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130;
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='${height}'></iframe>`;
                    elem.appendChild(ad);
                  }
                  break;
                case 4:
                  if (!elem.getElementsByClassName('sogou-wrap').length) {
                    let ad = document.createElement('div');
                    ad.className = "sogou-wrap";
                    // ad.innerHTML = "<iframe src='./sogou005.html' frameborder='0' scrolling='no' width='100%' height='100'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130;
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='${height}'></iframe>`;
                    elem.appendChild(ad);
                  }
                  break;
                case 5:
                  if (!elem.getElementsByClassName('sogou-wrap').length) {
                    let ad = document.createElement('div');
                    ad.className = "sogou-wrap";
                    // ad.innerHTML = "<iframe src='./sogou006.html' frameborder='0' scrolling='no' width='100%' height='130'></iframe>";
                    const index = parseInt(Math.random() * 6 + 1);
                    const height = [1, 3, 5].indexOf(index) !== -1 ? 100 : 130;
                    ad.innerHTML = `<iframe src='./sogou00${index}.html' frameborder='0' scrolling='no' width='100%' height='${height}'></iframe>`;
                    elem.appendChild(ad);
                  }
                  break;
              }
            })
        });
      }).catch(err => {
        console.log('err: ', err);
      })
    },
    handleItemClick: function (index) {
      // deactivated 获取到的scrollTop有时候会一直为0， 所以修改为在跳转之前获取scrollTop
      // this.scroll_position = this.$refs.current[this.current_index].scrollTop;
      console.log("document.body.scrollTop: ", document.documentElement.scrollTop);
      this.$router.push({name: 'detail', params: {story_url: encodeURIComponent((this.relatedNewsList[index].dataUrl)), story_related : this.relatedNewsList[index]}})
    },
    setDefaultPortrait (e) {
      e.srcElement.src = this.defaultPortrait;
      // 防止默认图片也加载不了
      e.srcElement.onerror = null;
    },
    setDefaultImg (e) {
      e.srcElement.src = this.defaultImg;
      e.srcElement.onerror = null;
    },
    gotoIndexPage: function (event) {
      this.$router.push({name: 'index'});
    },
  }
}
</script>

<style scoped>

body {
  padding: 0;
  margin: 0;
  background-color: white;
}
.story-content-container {
  padding-top: 20px;
}
#detail {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.story-container {
  padding: 10px 14px;
  text-align: left;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  /* overflow: hidden;
  height: 100vh;
  box-sizing: border-box; */
}
.story-headline {
  font-size: 22px;
  font-weight: 700;
}

.story-category {
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid#eee;
}
.story-category .author-avatar {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.story-category .author-name {
  /* margin-left: 8px; */
  font-size: 16px;
  color: rgba(0, 0, 0, 0.5);
}

.loading,
.loading-failure,
.empty {
  margin-top: 16px;
  color: #777;
  text-align: center;
  font-size: 22px;
}

.content-item {
  margin-top: 10px;
}
.content-text {
  line-height: 40px;
  font-size: 20px;
}
.content-img {
  width: 100%;
  border-radius: 4px;
}
.subtitle {
  width: 80%;
  font-size: 18px;
  font-weight: bold;
}

.detail-ad-container {
  /* border-bottom: 1vw solid rgba(0, 0, 0, 0.1); */
  padding: 8px 0;
  overflow: hidden;
  text-align: left;
}

.related-ad-container {
  padding: 10px 0;
  padding-bottom: 0px;
}

.goto-index {
  position: fixed;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  line-height: 20px;
  font-size: 16px;
  /* line-height: 15vw; */
  right: 4px;
  bottom: 100px;
  z-index: 999;
  background-color: red;
  color: yellow;
  padding: 6px;
  text-align: center;
}

.recommend-title {
  position: relative;
  padding: 0.24rem 0;
}
.recommend-title h2 {
  position: relative;
  font-size: 20px;
  color: #3F4146;
  padding-bottom: 10px;
  font-weight: 400;
}
.recommend-title h2:after {
  content: " ";
  position: absolute;
  left: 0;
  width: 100%;
  height: 1px;
  color: #e5e5e5;
  bottom: 0;
  border-bottom: 1px solid #e5e5e5;
}
.recommend-title .line {
  position: absolute;
  z-index: 1;
  left: 0;
  width: 80px;
  height: 1px;
  background-color: red;
  bottom: 0;
}
.recommend-content /deep/ .story-item-container {
  margin: 0 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/detail.vue